"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apolloClient = void 0;
var _defineProperty2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.to-string");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _unfetch = _interopRequireDefault(require("unfetch"));
var _apolloLinkHttp = require("apollo-link-http");
var _apolloLinkContext = require("apollo-link-context");
var _apolloBoost = require("apollo-boost");
var _store = _interopRequireDefault(require("../store"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // import ApolloClient, { InMemoryCache } from 'apollo-boost'
var httpLink = (0, _apolloLinkHttp.createHttpLink)({
  uri: process.env.VUE_APP_HASURA_URI,
  fetch: _unfetch.default
});
var authLink = (0, _apolloLinkContext.setContext)(/*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(_, _ref) {
    var headers, token;
    return regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          headers = _ref.headers;
          _context.next = 1;
          return _store.default.getters.fbuser.getIdToken();
        case 1:
          token = _context.sent.toString();
          return _context.abrupt("return", {
            headers: _objectSpread(_objectSpread({}, headers), {}, {
              authorization: token ? "Bearer ".concat(token) : ''
            })
          });
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var apolloClient = exports.apolloClient = new _apolloBoost.ApolloClient({
  link: authLink.concat(httpLink),
  cache: new _apolloBoost.InMemoryCache()
});